export default `precision highp float;
#define GLSLIFY 1

float luma(vec3 color) {
  return dot(color, vec3(0.299, 0.587, 0.114));
}

float luma(vec4 color) {
  return dot(color.rgb, vec3(0.299, 0.587, 0.114));
}

float brightPass(vec4 color, float threshold) {
    return step(threshold, luma(color));
}

uniform sampler2D tMap;
uniform sampler2D tEmissive;
uniform float uThreshold;
varying vec2 vUv;

void main() {
    vec4 tex = texture2D(tMap, vUv);
    vec4 emissive = texture2D(tEmissive, vUv) + tex * brightPass(tex, uThreshold);
    if(emissive.a <= 0.) {
        discard;
    }
    gl_FragColor = emissive;
}`